import GameBaseState from "./GameBaseState";
import Logger from "@js/logger";
import * as Accounts from "@js/account";
import { IStateType } from "./IGameState";
import BusinessManager from "@/js/controls";
import { Modal } from "ant-design-vue";
import { yunpb } from "@/types/protobuf";
export default class GameStateMissEnterGame extends GameBaseState {
  private playerStatusData;
  private myType = IStateType.CAN_RETURN_GAME;
  constructor() {
    super();
    this.playerStatusData = this.playGameStore.playerStatusData;
  }
  onPageReload() {
    Logger.log(`GameState ${IStateType[this.myType]} onPageReload`);
    this.playGameStore.resetModalState();
    this.playGameStore.isQueueing = false;
    BusinessManager.ConfirmAlreadyMissStatus();
    Accounts.setCurrentGame(null);
    Modal.confirm({
      title: "Tips",
      content: "Your queue has been missed, please queue again.",
      okText: "Requeue",
      cancelText: "Cancle",
      centered: true,
      onOk: () => {
        // 请求清理字段
        this.playGame();
        BusinessManager.ConfirmAlreadyMissStatus();
      },
      onCancel: () => {
        this.setState(IStateType.FREE);
        BusinessManager.ConfirmAlreadyMissStatus();
      },
    });
  }
  playGame(game?: yunpb.IGetGameRoomInfoRsp | null) {
    Logger.log(`GameState ${IStateType[this.myType]} playGame`);
    if (game) {
      Accounts.setSelectGame(game as yunpb.IGameNode);
    }
    this.reQueueGame();
  }
  exitGame() {
    Logger.log(`GameState ${IStateType[this.myType]} exitGame`);
    this.playGameStore.handleGameExit();
    this.setState(IStateType.FREE);
  }
}
